import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HomeMaxIcon(props: IconProps) {
    return <Icon {...props} iconKey={"home_max"}/>
}
